// Types
import { State, Notification } from 'types'

export const notificationsDomain = (state: State) => state.notifications
export const notificationsEntities = (state: State) => state.entities.notifications
export const localNotificationsEntities = (state: State) => state.notifications.entities

export const unseenNotificationSelector = (state: State): Array<Notification> => {
  const notifications = notificationsEntities(state)
  const localNotifications = localNotificationsEntities(state)
  const allNotifications = { ...notifications, ...localNotifications }
  const notificationsList = Object.keys(allNotifications).map(id => allNotifications[id])
  return notificationsList.filter(({ seen }) => !seen)
}
